import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';
import queryString from 'query-string';
import { useLocation } from 'react-router';

const useStyles = makeStyles((theme) => ({
    accordionRoot: {
        backgroundColor: theme.palette.background.paper,
        border: '1px solid rgba(0, 0, 0, .125)',
        boxShadow: 'none',
        '&:not(:last-child)': {
            borderBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
        '&$expanded': {
            margin: 'auto',
        },
    },
    accordionExpanded: {},
    summaryRoot: {
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
        borderBottom: '1px solid rgba(0, 0, 0, .125)',
        marginBottom: -1,
        minHeight: 56,
        '&$expanded': {
            minHeight: 56,
        },
    },
    summaryContent: {
        '&$expanded': {
            margin: '12px 0',
        },
    },
    summaryExpanded: {},
    detailsRoot: {
        padding: theme.spacing(2),
    },
    smalltext: {
        fontSize: '14px',
        color: theme.palette.primary.main
    },
}))

export default function Policy() {
    const classes = useStyles();
    const location = useLocation();
    const qs = queryString.parse(location.search)
    let x = ("page" in qs) ? qs['page'] : 'tos'
    const [expanded, setExpanded] = React.useState(x);

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    return (
        <div>
            <MuiAccordion classes={{ root: classes.accordionRoot, expanded: classes.accordionExpanded }} square expanded={expanded === 'tos'} onChange={handleChange('tos')}>
                <MuiAccordionSummary classes={{ root: classes.summaryRoot, content: classes.summaryContent, expanded: classes.summaryExpanded }} expandIcon={<ExpandMoreIcon />} aria-controls="tosd-content" id="tosd-header">
                    <Typography variant="h4">1. Website Terms and Conditions of Use</Typography>
                </MuiAccordionSummary>
                <MuiAccordionDetails classes={{ root: classes.detailsRoot }}>
                    <div>
                        <h2>1. Terms</h2>

                        <p>By accessing this Website, accessible from https://landlawsofindia.com/, you are agreeing to be bound by these Website Terms and Conditions of Use and agree that you are responsible for the agreement with any applicable local laws. If you disagree with any of these terms, you are prohibited from accessing this site. The materials contained in this Website are protected by copyright and trade mark law.</p>

                        <h2>2. Use License</h2>

                        <p>Permission is granted to temporarily download one copy of the materials on Land Rights Initiative, Centre for Policy Research's Website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:</p>

                        <ul>
                            <li>modify or copy the materials;</li>
                            <li>use the materials for any commercial purpose or for any public display;</li>
                            <li>attempt to reverse engineer any software contained on Land Rights Initiative, Centre for Policy Research's Website;</li>
                            <li>remove any copyright or other proprietary notations from the materials; or</li>
                            <li>transferring the materials to another person or "mirror" the materials on any other server.</li>
                        </ul>

                        <p>This will let Land Rights Initiative, Centre for Policy Research to terminate upon violations of any of these restrictions. Upon termination, your viewing right will also be terminated and you should destroy any downloaded materials in your possession whether it is printed or electronic format.</p>

                        <h2>3. Disclaimer</h2>

                        <p>All the materials on Land Rights Initiative, Centre for Policy Research’s Website are provided "as is". Land Rights Initiative, Centre for Policy Research makes no warranties, may it be expressed or implied, therefore negates all other warranties. Furthermore, Land Rights Initiative, Centre for Policy Research does not make any representations concerning the accuracy or reliability of the use of the materials on its Website or otherwise relating to such materials or any sites linked to this Website.</p>

                        <h2>4. Limitations</h2>

                        <p>Land Rights Initiative, Centre for Policy Research or its suppliers will not be hold accountable for any damages that will arise with the use or inability to use the materials on Land Rights Initiative, Centre for Policy Research’s Website, even if Land Rights Initiative, Centre for Policy Research or an authorize representative of this Website has been notified, orally or written, of the possibility of such damage. Some jurisdiction does not allow limitations on implied warranties or limitations of liability for incidental damages, these limitations may not apply to you.</p>

                        <h2>5. Revisions and Errata</h2>

                        <p>The materials appearing on Land Rights Initiative, Centre for Policy Research’s Website may include technical, typographical, or photographic errors. Land Rights Initiative, Centre for Policy Research will not promise that any of the materials in this Website are accurate, complete, or current. Land Rights Initiative, Centre for Policy Research may change the materials contained on its Website at any time without notice. Land Rights Initiative, Centre for Policy Research does not make any commitment to update the materials.</p>

                        <h2>6. Links</h2>

                        <p>Land Rights Initiative, Centre for Policy Research has not reviewed all of the sites linked to its Website and is not responsible for the contents of any such linked site. The presence of any link does not imply endorsement by Land Rights Initiative, Centre for Policy Research of the site. The use of any linked website is at the user’s own risk.</p>

                        <h2>7. Site Terms of Use Modifications</h2>

                        <p>Land Rights Initiative, Centre for Policy Research may revise these Terms of Use for its Website at any time without prior notice. By using this Website, you are agreeing to be bound by the current version of these Terms and Conditions of Use.</p>

                        <h2>8. Your Privacy</h2>

                        <p>Please read our Privacy Policy.</p>

                        <h2>9. Governing Law</h2>

                        <p>Any claim related to Land Rights Initiative, Centre for Policy Research's Website shall be governed by the laws of India without regards to its conflict of law provisions.</p>

                    </div>
                </MuiAccordionDetails>
            </MuiAccordion>
            <MuiAccordion classes={{ root: classes.accordionRoot, expanded: classes.accordionExpanded }} square expanded={expanded === 'privacy'} onChange={handleChange('privacy')}>
                <MuiAccordionSummary classes={{ root: classes.summaryRoot, content: classes.summaryContent, expanded: classes.summaryExpanded }} expandIcon={<ExpandMoreIcon />} aria-controls="privacyd-content" id="privacyd-header">
                    <Typography variant="h4">2. Privacy Policy for Land Rights Initiative, Centre for Policy Research</Typography>
                </MuiAccordionSummary>
                <MuiAccordionDetails classes={{ root: classes.detailsRoot }}>
                    <div>
                        <p>At Mapping Indian Land Laws, accessible from https://landlawsofindia.com/, one of our main priorities is the privacy of our visitors. This Privacy Policy document contains types of information that is collected and recorded by Mapping Indian Land Laws and how we use it.</p>

                        <p>If you have additional questions or require more information about our Privacy Policy, do not hesitate to contact us.</p>

                        <h2>General Data Protection Regulation (GDPR)</h2>
                        <p>We are a Data Controller of your information.</p>

                        <p>Land Rights Initiative, Centre for Policy Research legal basis for collecting and using the personal information described in this Privacy Policy depends on the Personal Information we collect and the specific context in which we collect the information:</p>
                        <ul>
                            <li>Land Rights Initiative, Centre for Policy Research needs to perform a contract with you</li>
                            <li>You have given Land Rights Initiative, Centre for Policy Research permission to do so</li>
                            <li>Processing your personal information is in Land Rights Initiative, Centre for Policy Research's legitimate interests</li>
                            <li>Land Rights Initiative, Centre for Policy Research needs to comply with the law</li>
                        </ul>

                        <p>Land Rights Initiative, Centre for Policy Research will retain your personal information only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use your information to the extent necessary to comply with our legal obligations, resolve disputes, and enforce our policies.</p>

                        <p>If you are a resident of the European Economic Area (EEA), you have certain data protection rights. If you wish to be informed what Personal Information we hold about you and if you want it to be removed from our systems, please contact us.</p>

                        <p>In certain circumstances, you have the following data protection rights:</p>
                        <ul>
                            <li>The right to access, update or to delete the information we have on you.</li>
                            <li>The right of rectification.</li>
                            <li>The right to object.</li>
                            <li>The right of restriction.</li>
                            <li>The right to data portability</li>
                            <li>The right to withdraw consent</li>
                        </ul>

                        <h2>Log Files</h2>

                        <p>Mapping Indian Land Laws follows a standard procedure of using log files. These files log visitors when they visit websites. All hosting companies do this and a part of hosting services' analytics. The information collected by log files include internet protocol (IP) addresses, browser type, Internet Service Provider (ISP), date and time stamp, referring/exit pages, and possibly the number of clicks. These are not linked to any information that is personally identifiable. The purpose of the information is for analyzing trends, administering the site, tracking users' movement on the website, and gathering demographic information.</p>

                        <h2>Cookies and Web Beacons</h2>

                        <p>Like any other website, Mapping Indian Land Laws uses 'cookies'. These cookies are used to store information including visitors' preferences, and the pages on the website that the visitor accessed or visited. The information is used to optimize the users' experience by customizing our web page content based on visitors' browser type and/or other information.</p>

                        <p>For more general information on cookies, please read <a className={classes.smalltext} href="https://youtu.be/TBR-xtJVq7E">"A look at cookies"</a>.</p>



                        <h2>Privacy Policies</h2>

                        <p>You may consult this list to find the Privacy Policy for each of the advertising partners of Mapping Indian Land Laws.</p>

                        <p>Third-party ad servers or ad networks uses technologies like cookies, JavaScript, or Web Beacons that are used in their respective advertisements and links that appear on Mapping Indian Land Laws, which are sent directly to users' browser. They automatically receive your IP address when this occurs. These technologies are used to measure the effectiveness of their advertising campaigns and/or to personalize the advertising content that you see on websites that you visit.</p>

                        <p>Note that Mapping Indian Land Laws has no access to or control over these cookies that are used by third-party advertisers.</p>

                        <h2>Third Party Privacy Policies</h2>

                        <p>Mapping Indian Land Laws's Privacy Policy does not apply to other advertisers or websites. Thus, we are advising you to consult the respective Privacy Policies of these third-party ad servers for more detailed information. It may include their practices and instructions about how to opt-out of certain options. </p>

                        <p>You can choose to disable cookies through your individual browser options. To know more detailed information about cookie management with specific web browsers, it can be found at the browsers' respective websites.</p>

                        <h2>Children's Information</h2>

                        <p>Another part of our priority is adding protection for children while using the internet. We encourage parents and guardians to observe, participate in, and/or monitor and guide their online activity.</p>

                        <p>Mapping Indian Land Laws does not knowingly collect any Personal Identifiable Information from children under the age of 13. If you think that your child provided this kind of information on our website, we strongly encourage you to contact us immediately and we will do our best efforts to promptly remove such information from our records.</p>

                        <h2>Online Privacy Policy Only</h2>

                        <p>Our Privacy Policy created at GDPRPrivacyPolicy.net) applies only to our online activities and is valid for visitors to our website with regards to the information that they shared and/or collect in Mapping Indian Land Laws. This policy is not applicable to any information collected offline or via channels other than this website.</p>

                        <h2>Consent</h2>

                        <p>By using our website, you hereby consent to our Privacy Policy and agree to its terms.</p>
                    </div>
                </MuiAccordionDetails>
            </MuiAccordion>
        </div>
    );
}
